import React from 'react';
import { Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import './style.css';

import {
  StyledFlex1
} from 'modules/Page/Components/Partials/style';

const TabsContainer = styled.div`
  background: #fff;
  .ant-tabs-nav {
    margin: 0;
    &::before {
      border-bottom: 1px solid #f0f0f0;
    }
  }
  .ant-tabs-tab {
    padding: 16px 24px;
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    &-active {
      font-weight: 600;
    }
  }
`;

const PlacementPrepWrapper = styled.div`
  display: inline-block;
`;

const TopNavigation = ({ studentId }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const ddd = location.pathname;

  const getSelectedKey = () => {
    if (ddd?.includes('roles/viewrole')) {
      return ['/roles'];
    } else if (ddd === '/assessment' || ddd === '/practice') {
      return [ddd];
    }
    return [];
  };

  const handleTabChange = (key) => {
    navigate(`/${key}`);
  };

  const getActiveKey = () => {
    if (ddd.startsWith('/practice')) return 'practice';
    return 'assessment';
  };

  const placementPrepItem = {
    key: '/practice',
    onClick: () => handleTabChange('practice'),
    label: (
      <PlacementPrepWrapper>
        Practice
      </PlacementPrepWrapper>
    ),
    style: {
      color: getActiveKey() === 'practice' ? '#4F46E5' : 'rgba(0, 0, 0, 0.65)',
      fontWeight: getActiveKey() === 'practice' ? 600 : 400,
      padding: '0 16px',
      margin: '0 16px 0 0',
      lineHeight: '46px',
      cursor: 'pointer'
    }
  };

  return (
    <>
      <StyledFlex1>
        <TabsContainer>
          <Menu 
            mode="horizontal" 
            selectedKeys={getSelectedKey()}
            items={[
              {
                key: '/assessment',
                onClick: () => handleTabChange('assessment'),
                label: 'Assessment',
                style: {
                  color: getActiveKey() === 'assessment' ? '#4F46E5' : 'rgba(0, 0, 0, 0.65)',
                  fontWeight: getActiveKey() === 'assessment' ? 600 : 400,
                  padding: '0 16px',
                  margin: '0 16px 0 0',
                  lineHeight: '46px',
                  cursor: 'pointer'
                }
              },
              placementPrepItem
            ]}
          />
        </TabsContainer>
      </StyledFlex1>
    </>
  );
};

export default TopNavigation;